import { Container, Segment } from 'semantic-ui-react';
import React from 'react';
import PropTypes from 'prop-types';
import { ContainerOverride } from './SegmentFull.style';

// Render with Container override if page type passed in. Otherwise use default styles.
const SegmentFull = props => {
  const { page, theme, children, text } = props;
  return page ? (
    <ContainerOverride page={page} className="ui container override">
      <Container as="main" text={text} className={`container--${theme}`}>
        <Segment className="segment--full" textAlign="center">
          {children}
        </Segment>
      </Container>
    </ContainerOverride>
  ) : (
    <Container as="main" text={text} className={`container--${theme}`}>
      <Segment className="segment--full" textAlign="center">
        {children}
      </Segment>
    </Container>
  );
};

SegmentFull.propTypes = {
  text: PropTypes.bool,
  theme: PropTypes.string,
  children: PropTypes.node.isRequired,
  page: PropTypes.string
};

SegmentFull.defaultProps = {
  // bulma container text attribute to narrow
  // false to make wider
  text: true,
  theme: 'bg'
};

export default SegmentFull;
